import { Palette } from 'lucide-react';
import type { SubtitleStyle } from '@/types';

interface ColorSettingsProps {
  style: SubtitleStyle;
  onUpdate: (updates: Partial<SubtitleStyle>) => void;
}

export function ColorSettings({ style, onUpdate }: ColorSettingsProps) {
  return (
    <section>
      <div className="settings-section-header">
        <div className="settings-icon-box settings-icon-box-purple">
          <Palette size={14} className="text-purple-600" />
        </div>
        <h3 className="settings-section-title">色設定</h3>
      </div>
      <div className="space-y-3 pl-9">
        {/* 文字色 */}
        <div className="settings-field-row">
          <label className="settings-label settings-label-fixed">文字色</label>
          <input
            type="color"
            value={style.textColor}
            onChange={(e) => onUpdate({ textColor: e.target.value })}
            className="color-input w-8 h-8"
            aria-label="文字色を選択"
            title={`文字色: ${style.textColor}`}
          />
          <input
            type="text"
            value={style.textColor}
            onChange={(e) => onUpdate({ textColor: e.target.value })}
            className="input-base w-20 font-mono text-xs py-1 px-2"
            aria-label="文字色のカラーコード"
          />
        </div>

        {/* 縁取り */}
        <div className="settings-field-row">
          <label className="settings-label settings-label-fixed">縁取り</label>
          <input
            type="color"
            value={style.strokeColor}
            onChange={(e) => onUpdate({ strokeColor: e.target.value })}
            className="color-input w-8 h-8"
            aria-label="縁取り色を選択"
            title={`縁取り色: ${style.strokeColor}`}
          />
          <input
            type="range"
            min="0"
            max="16"
            step="1"
            value={style.strokeWidth}
            onChange={(e) => onUpdate({ strokeWidth: parseInt(e.target.value) })}
            className="range-slider range-slider-flex"
            aria-label="縁取りの太さ"
          />
          <span className="settings-value">{style.strokeWidth}px</span>
        </div>

        {/* 背景 */}
        <div className="settings-field-row">
          <label className="settings-label settings-label-fixed">背景</label>
          <input
            type="color"
            value={style.backgroundColor}
            onChange={(e) => onUpdate({ backgroundColor: e.target.value })}
            className="color-input w-8 h-8"
            aria-label="背景色を選択"
            title={`背景色: ${style.backgroundColor}`}
          />
          <input
            type="range"
            min="0"
            max="100"
            step="5"
            value={style.backgroundOpacity}
            onChange={(e) => onUpdate({ backgroundOpacity: parseInt(e.target.value) })}
            className="range-slider range-slider-flex"
            aria-label="背景の不透明度"
          />
          <span className="settings-value">{style.backgroundOpacity}%</span>
        </div>
      </div>
    </section>
  );
}
